module.exports = __webpack_public_path__ + "media/images/switch-on-72afe02f60e2fb0192dc2e3b0ba8cf69.svg";